(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-campaign-banners"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bannerStart = Date.parse('2026-10-25T00:00:00-07:00');
  const holidayStart = Date.parse('2026-10-29T00:00:00-07:00');
  let timer;
  function updateCampaigns() {
    clearTimeout(timer);
    const now = Date.now();
    const phase = now >= holidayStart ? 'holiday' : now >= bannerStart ? 'sale' : 'preview';
    document.querySelectorAll('[data-al-campaign]').forEach(root => {
      root.querySelectorAll('[data-campaign-phase]').forEach(panel => {
        panel.hidden = panel.dataset.campaignPhase !== phase;
      });
    });
    const next = now < bannerStart ? bannerStart : now < holidayStart ? holidayStart : null;
    if (next !== null) timer = setTimeout(updateCampaigns, Math.min(next - now + 20, 3600000));
  }
  updateCampaigns();
  document.addEventListener('visibilitychange', updateCampaigns);
  document.addEventListener('shopify:section:load', updateCampaigns);
})();

  } catch(e) { console.error(e); }
})();
})();
